export default __webpack_public_path__ + "static/media/img_share_passboard.51e274a5.png";